module.exports = __webpack_public_path__ + "static/img/result_ls_ceil_angle.91fa693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_ceil_angle.jpg
// module id = 1pSi
// module chunks = 3